// Situação de um conector de ERP do catálogo (H3) → status e rótulo do card
// (H4, PO1-3617). Função pura. Os chips de situação existentes não mudam:
//   nao_configurado → 'disponivel' ("Não configurado")
//   ativo           → 'ativa' ("Ativa · v1.0")
//   agendado        → com vigente: 'ativa' ("Troca para v2.0 em dd/mm");
//                     sem vigente: 'disponivel' ("Agendada para dd/mm")
import { STATUS, ROTULO_STATUS } from "./statusDoConector";
import { DIRECOES_CATALOGO, rotuloTipo, rotuloCapacidade } from "./classificacao";

export const SITUACAO = { NAO_CONFIGURADO: "nao_configurado", ATIVO: "ativo", AGENDADO: "agendado" };

// dd/mm a partir do ISO do backend, sem converter fuso (mesmo corte do
// VinculoConectorTab do Admin).
export function formatarDiaMes(iso) {
  if (!iso) return "";
  const s = String(iso);
  if (s.length < 10) return s;
  return `${s.slice(8, 10)}/${s.slice(5, 7)}`;
}

export function formatarData(iso) {
  if (!iso) return "—";
  const s = String(iso);
  return s.length >= 10 ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : s;
}

export function statusConectorErp(situacao) {
  const sit = situacao || {};
  const vigente = sit.vigente || null;
  const agendado = sit.agendado || null;
  if (sit.status === SITUACAO.AGENDADO && agendado) {
    if (vigente) return { status: STATUS.ATIVA, rotulo: `Troca para v${agendado.versao} em ${formatarDiaMes(agendado.vigenciaInicio)}` };
    return { status: STATUS.DISPONIVEL, rotulo: `Agendada para ${formatarDiaMes(agendado.vigenciaInicio)}` };
  }
  if (sit.status === SITUACAO.ATIVO && vigente) return { status: STATUS.ATIVA, rotulo: `Ativa · v${vigente.versao}` };
  return { status: STATUS.DISPONIVEL, rotulo: ROTULO_STATUS.disponivel };
}

// Complemento da versão no seletor (PO1-3655): o que distingue o nome da versão
// do nome do card. "TOTVS Protheus (versão antiga)" no card "TOTVS Protheus" →
// "versão antiga"; "Senior G5 (descontinuada ...)" → "descontinuada ...".
// Mesmo nome do card, ou sem nome → null (o seletor mostra só "v1.0").
export function rotuloDaVersao(versao, nomeCard) {
  const nome = versao && versao.nome ? String(versao.nome).trim() : "";
  if (!nome || nome === String(nomeCard || "").trim()) return null;
  const parenteses = nome.match(/\(([^)]+)\)\s*$/);
  return parenteses ? parenteses[1].trim() : nome;
}

// Versão de referência do card: a vigente, senão a última do catálogo.
export function versaoReferencia(item) {
  const versoes = (item && item.versoes) || [];
  const vigente = item && item.situacao && item.situacao.vigente;
  if (vigente) {
    const v = versoes.find((x) => String(x.versao) === String(vigente.versao));
    if (v) return v;
  }
  return versoes.length ? versoes[versoes.length - 1] : null;
}

function siglaDe(nome, key) {
  const base = String(nome || key || "??").replace(/[^A-Za-z0-9 ]/g, " ").trim();
  const partes = base.split(/\s+/).filter(Boolean);
  const sigla = partes.length >= 2 ? partes[0][0] + partes[1][0] : base.slice(0, 2);
  return (sigla || "??").toUpperCase();
}

// Item da API (GET /conectores-erp) → card no formato dos 6 fixos, para a
// grade, os filtros e as etiquetas funcionarem igual. `origem: 'catalogo'`
// manda o clique para o ConectorErpDrawer.
export function cardDoCatalogo(item) {
  const ref = versaoReferencia(item);
  const capacidades = ref ? ref.capacidades || [] : [];
  const nome = item.nome || item.conectorKey;
  return {
    key: `catalogo:${item.conectorKey}`,
    origem: "catalogo",
    conectorKey: item.conectorKey,
    nome,
    sigla: siglaDe(nome, item.conectorKey),
    tipoSistema: item.categoria,
    categoria: rotuloTipo(item.categoria),
    direcao: DIRECOES_CATALOGO[item.direcao] || item.direcao || "",
    descricaoCurta: capacidades.length ? `Troca ${capacidades.map(rotuloCapacidade).join(", ")} com o Hub.` : "Conector do catálogo de integrações.",
    capacidades,
    versoes: item.versoes || [],
    situacao: item.situacao || { status: SITUACAO.NAO_CONFIGURADO, vigente: null, agendado: null },
    campos: [],
    campoAtivador: null,
    avisos: [],
    gerenciado: false,
    rotulos: {},
  };
}
